export default {
	colors: {
		accounts: "#ff5559",
		write: "#ff0",

		//default value, must be overwritten
		main: "#aaa",

		white: "#fff",
		lightGrey: "#ddd",
		black: "#333",
		red: "#f92672",
		orange: "#fd971f",
		yellow: "#e6db74",
		green: "#a6e22e",
		blue: "#66d9ef",
		purple: "#ae81ff",
	},

	functions: {
		shadow: (height, over = 0) => {
			const h = height - over;
			return `
				box-shadow:
					0px	${ 3 * h }px ${     h }px ${ -h }px rgba(0, 0, 0, ${ h / 10 }),
					0px ${     h }px ${ 2 * h }px ${  h }px rgba(0, 0, 0, ${ h / 20 });
				z-index: ${ height };
			`;
		},
	},
};
